<template>
  <div class="dr-notice" :style="barStyle">
    <img v-if="icon" class="dr-notice__icon-img" :src="icon" alt="" />
    <span v-else class="dr-notice__icon">📢</span>
    <div class="dr-notice__viewport" :class="viewportClass">
      <transition v-if="items.length > 1" :name="transitionName" mode="out-in">
        <div
          :key="activeIndex"
          class="dr-notice__line"
          :style="itemStyle(activeItem)"
          @click="onTap(activeItem)"
        >
          {{ label(activeItem) }}
        </div>
      </transition>
      <div
        v-else-if="items.length === 1"
        class="dr-notice__line"
        :style="itemStyle(items[0])"
        @click="onTap(items[0])"
      >
        {{ label(items[0]) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DecorationNoticeBar",
  props: {
    items: { type: Array, default: () => [] },
    icon: { type: String, default: "" },
    textColor: { type: String, default: "#333333" },
    interval: { type: Number, default: 5000 },
    scrollDirection: { type: String, default: "vertical" },
  },
  data() {
    return { activeIndex: 0, timer: null };
  },
  computed: {
    vertical() {
      return this.scrollDirection !== "horizontal";
    },
    transitionName() {
      return this.vertical ? "notice-v" : "notice-h";
    },
    viewportClass() {
      return this.vertical ? "is-vertical" : "is-horizontal";
    },
    barStyle() {
      return { color: this.textColor || "#333333" };
    },
    activeItem() {
      return this.items[this.activeIndex] || {};
    },
  },
  watch: {
    items: {
      handler() {
        this.activeIndex = 0;
        this.restartTimer();
      },
      deep: true,
    },
    interval() {
      this.restartTimer();
    },
  },
  mounted() {
    this.restartTimer();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    label(it) {
      return (it && (it.name != null ? it.name : it.label)) || "";
    },
    itemStyle(it) {
      if (!it) return {};
      const s = {};
      if (it.textColor) s.color = it.textColor;
      if (it.bgColor) s.background = it.bgColor;
      return s;
    },
    onTap(it) {
      this.$emit("click-item", it);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    restartTimer() {
      this.clearTimer();
      if (!this.items || this.items.length <= 1) return;
      const ms = Math.max(parseInt(this.interval, 10) || 5000, 1000);
      this.timer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.items.length;
      }, ms);
    },
  },
};
</script>

<style scoped>
.dr-notice {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  font-size: 13px;
  background: transparent;
  overflow: hidden;
}
.dr-notice__icon {
  flex-shrink: 0;
  margin-right: 8px;
  line-height: 36px;
}
.dr-notice__icon-img {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  object-fit: contain;
}
.dr-notice__viewport {
  flex: 1;
  min-width: 0;
  height: 36px;
  line-height: 36px;
  position: relative;
  overflow: hidden;
}
.dr-notice__line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  padding: 0 2px;
  box-sizing: border-box;
}
.notice-v-enter-active,
.notice-v-leave-active,
.notice-h-enter-active,
.notice-h-leave-active {
  transition: transform 0.4s ease, opacity 0.4s ease;
}
.notice-v-enter {
  transform: translateY(100%);
  opacity: 0;
}
.notice-v-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
.notice-h-enter {
  transform: translateX(100%);
  opacity: 0;
}
.notice-h-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.notice-v-enter-to,
.notice-v-leave,
.notice-h-enter-to,
.notice-h-leave {
  transform: translate(0, 0);
  opacity: 1;
}
</style>
